$(document).ready(function () {
    var current_lg = $('html').attr('lang');
    if(current_lg == "nl"){
        var cstmproducttext = `<p class="dont_see_color">Zie je jouw kleur niet? <a href="/pages/contact">Neem contact met ons op</a> om de mogelijkheden voor maatwerk te bespreken.</p>`;
    }else{
        var cstmproducttext = `<p class="dont_see_color">Don't see your colour? <a href="https://veloreformer.com/pages/contact">Contact us</a> to discuss custom options.</p>`;
    }
    $('.dont_see_color_main').html(cstmproducttext);

    $('html[lang="nl"] .body-template-collection .ready_to_find .anchor_which_reformer').text('Of stuur ons direct een bericht via WhatsApp.');
});